var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"headerPushDown",attrs:{"fluid":""}},[_c('b-container',{staticClass:" ml-auto mr-auto"},[_c('shop-categories-panel',{attrs:{"searchTag":'ShowOnFrontPage'}}),_c('shop-icon-panel')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }